// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: whitesmoke;
}
.text-content{
    text-align: justify;
    color: rgb(96, 182, 222);
    padding-left: 5%;
    padding-right: 5%;
}
.delegate-email-input{
    display: flex;
    flex-direction: column;
    align-items: center;
}
button {
    background-color:  #0066b2;
    color: white;
}

`, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/home/home.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,YAAY;AAChB","sourcesContent":["body {\n    background-color: whitesmoke;\n}\n.text-content{\n    text-align: justify;\n    color: rgb(96, 182, 222);\n    padding-left: 5%;\n    padding-right: 5%;\n}\n.delegate-email-input{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\nbutton {\n    background-color:  #0066b2;\n    color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
